import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function SearchNoResult() {
    return (_jsx(Container, { children: _jsx(NoResultText, { children: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." }) }));
}
const Container = styled.View `
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
const NoResultText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardMedium};
  padding-bottom: 120px;
  color: ${() => color.gray50};
`;
